import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { ActionItemDetails, ActionItemDetailsStore } from '@core/models/action-item-templates/action-item-details.model';

@Injectable({
  providedIn: 'root'
})
export class ActionItemDetailsStoreService {

  private readonly _initialStoreData: ActionItemDetailsStore = {
    actionItemDetails: null,
    sysText: null
  };

  private actionItemDetailsStore: BehaviorSubject<ActionItemDetailsStore>;  
  private store$: Observable<ActionItemDetailsStore>;

  private readonly templateNames = {
    actionItemDetails: "actionItemDetails",
    leavingPage: "leavingPage",
    unsavedChanges: "unsavedChanges",
    deleteConfirmation: "deleteConfirmation"
  };

  constructor() {
    this.actionItemDetailsStore = new BehaviorSubject(this._initialStoreData);
    this.store$ = this.actionItemDetailsStore.asObservable();
  }

  public get store() {
    return this.actionItemDetailsStore.value;
  }

  public get actionItemDetails() {
    return this.store.actionItemDetails;
  }

  public get sysText() {
    return this.store.sysText;
  }

  public get actionItemDetails$(): Observable<ActionItemDetails> {
    return this.store$.pipe(pluck('actionItemDetails'))
  }

  public get templates() {
    return this.templateNames;
  }

  public set actionItemDetails(actionItemDetails: ActionItemDetails) {
    const store = { ...this.store, actionItemDetails };
    this.actionItemDetailsStore.next(store);
  }

  public set sysText(sysText: any) {
    const store = { ...this.store, sysText };
    this.actionItemDetailsStore.next(store);
  }
 
  public unloadStore() {
    const store: ActionItemDetailsStore = {
      actionItemDetails: null,
      sysText: null
    }
    this.actionItemDetailsStore.next(store)
  }
}